module.exports = __webpack_public_path__ + "static/img/pic-avatar-vip2.c86d09e.png";